<template>
  <div class="tracked-measurements-form-input-groups">
    <template v-for="measurementType in group.MeasurementTypes">
      <component
         v-bind:is="componentName(measurementType.input_type)"
         v-show="componentShow(measurementType.overridable, measurementType.display)"
        :input="measurementType"
        :disabled="!edit"
        :clearable="false"
        :allData="allData"
        :originalData="originalData"
        @set:value="onValueEvent">
      </component>
    </template>
  </div>
</template>

<script>
import FormInputComplex from './form-input-types/cmpt-form-input-complex';
import FormInputSelect from './form-input-types/cmpt-form-input-select';
import FormInputSimpleWithSuggestions from './form-input-types/cmpt-form-input-simple-with-suggestions';
import FormInputSimple from './form-input-types/cmpt-form-input-simple';

export default {
  name: 'tracked-measurements-form-input-group-abstract',
  props: {
    group: {
      type: Object,
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    showAllMeasurements: {
      type: Boolean,
      required: true,
      default: false,
    },
    prefferedInputType: {
      type: String,
      required: false,
      default: null,
    },
    allData: {
      type: Object,
      required: false,
      default: null,
    },
    originalData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  components: {
    FormInputComplex,
    FormInputSelect,
    FormInputSimpleWithSuggestions,
    FormInputSimple,
  },
  methods: {
    componentName(value) {
      const name = value.replace(/_/g, '-');
      return `form-input-${name}`;
    },
    componentShow(overridable) {
      return overridable || this.showAllMeasurements;
    },
    onValueEvent(value) {
      this.$emit('set:value', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .tracked-measurements-form-input-groups {

  }

  .el-form-item--tracked-measurement__complex {


    .input-label {
      line-height: 1.5;
      padding: 0 0.5em;
      color: $gray-light;
      font-size: 0.75rem;
      display: inline-block;
      text-transform: uppercase;
    }
    .el-col--no-line-height {
      line-height: 1;
    }
    .el-col--unit {
      margin-top: 1.15em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/tracked-measurements-form-input-groups/group-abstract.vue